<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  toolBar
  .content-center
    .row.mx-0.py-2.px-1
      template(v-for="(sport, index) in order")
        .col-6.px-1.mb-2
          a.d-block(href="javascript:void(0);" @click="setMenu2x(sport)")
            .sport-wrap
              .flex-grow-1.pr-1
                img(:src="'/images/icon-sport-svg/' + getSportsImage(sport)", width='25' height='25')
              .text {{ sportsName[sport] }}
  footerNav
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import config from "@/config";
import mixinTypes from "@/library/mixinTypes";

export default {
  components: {
    toolBar,
    footerNav
  },
  mixins: [mixinTypes],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    menu1() {
      return this.$store.getters.menu1;
    },
    order() {
      return this.$store.state.layout.order.sports;
    },
    sports() {
      return Object.keys(this.$store.state.layout.sports);
    },
    sportsName() {
      return this.$store.state.layout.sports;
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    setMenu2x(e) {
      // $(".btn-parlay").removeClass("active");
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      if (this.menu0 == "parlay") {
        mi5["menu0"] = "parlay";
        mi5["menu1"] = "parlay";
        mi5["menu2"] = parseInt(e);
        mi5["menu3"] = "parlay";
      } else {
        mi5["menu0"] = "all";
        mi5["menu1"] = "today";
        mi5["menu2"] = parseInt(e);
        mi5["menu3"] = "hdpou";
        config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);
      }

      var changed = false;
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }

      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }

      this.$router.push("/prematch").catch(err => {});
    }
  }
};
</script>
